import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useController, useFormContext, } from 'react-hook-form';
import clsx from 'clsx';
import FormLabel from '@enquiryForm/components/FormLabel';
import FormGroup from '@enquiryForm/components/FormGroup';
import sanitizeTitle from '@widgets/shared/sanitizeTitle';
function RadioInput(props) {
    const { name, type, options, labelAttrs, } = props;
    const { control } = useFormContext();
    const { field: { onChange, value, }, fieldState: { invalid, isTouched, error, }, } = useController({ name, control });
    const onInputChange = (ev) => {
        if (type === 'checkbox') {
            const val = value;
            const newValue = (ev?.currentTarget.checked)
                ? [...val, ev?.currentTarget.value] // Add
                : val.filter((itemValue) => itemValue !== ev?.currentTarget.value); // Remove
            return onChange(newValue);
        }
        if (ev?.currentTarget.checked) {
            return onChange(ev?.currentTarget.value);
        }
        return false;
    };
    const checkSelectedState = (valueToCheck) => {
        if (type === 'checkbox') {
            return value.includes(valueToCheck);
        }
        return valueToCheck === value;
    };
    const renderOption = (option) => {
        const sanitizedId = `radio-${name}-${sanitizeTitle(option.value)}`;
        const classPrefix = type === 'radio' ? 'radio' : 'checkbox';
        let fieldIsInvalid = false;
        if (error) {
            const { message } = error;
            fieldIsInvalid = (typeof message === 'object')
                ? (message.fields ?? []).includes(option.value)
                : invalid;
        }
        const elementClass = clsx([
            classPrefix,
            { invalid: fieldIsInvalid },
        ]);
        return (_jsxs("div", { className: elementClass, children: [_jsx("input", { id: sanitizedId, name: name, type: type, value: option.value, checked: checkSelectedState(option.value), onChange: onInputChange, className: `${classPrefix}__input` }), _jsx("label", { htmlFor: sanitizedId, className: `${classPrefix}__label`, children: _jsxs("span", { children: [option.label, option.required && '*'] }) })] }, `${sanitizedId}-wrapper`));
    };
    const wrapperClass = clsx([type === 'radio' ? 'radios' : 'checkboxes']);
    return (_jsxs(FormGroup, { className: error ? 'form__group--error' : '', children: [_jsx(FormLabel, { ...labelAttrs }), _jsx("div", { className: wrapperClass, children: options.map(renderOption) })] }));
}
export default RadioInput;
